import {JsonObject, JsonProperty} from "json2typescript";

import {DataType, STRING_TYPE} from "../../stores/database-template/database-form-base";
import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TemplateColumnListItemInput")
export class TemplateColumnListItemInput {
    @JsonProperty()
    public id: string = "";
    public slug: string = "";

    @JsonProperty()
    public label: string = "";

    @JsonProperty()
    public type: DataType = STRING_TYPE;

    @JsonProperty()
    public note: string = "";

    @JsonProperty()
    public deleted: boolean = false;
    constructor(init?: Partial<TemplateColumnListItemInput>) {
        Object.assign(this, init);
    }
}

@JsonObject("TemplateUpsertInput")
export class TemplateUpsertInput {
    @JsonProperty()
    public title: string = "";

    @JsonProperty()
    public note: string = "";

    @JsonProperty()
    public templateColumnList: TemplateColumnListItemInput[] = JsonPropertyEmpty;
    constructor(init?: Partial<TemplateUpsertInput>) {
        Object.assign(this, init);
    }
}
